<template>
  <div id="campaign" :class="s.container">
    <div :class="s.header">
      <img :class="s.header_title" src="/img/pages/choikulove/specialcampaign/title.png" alt="">
    </div>
    <div :class="s.content">
      <div :class="s.campaign_main">
        <img :class="s.campaign_mainCopy" src="/img/pages/choikulove/specialcampaign/campaign-copy.svg" alt="">
        <img :class="s.campaign_intro" src="/img/pages/choikulove/specialcampaign/campaign-intro.svg" alt="">
        <img :class="s.campaign_yellowKumo" src="/img/pages/choikulove/specialcampaign/yellow-kumo.svg" alt="">
        <div :class="s.campaign_text">
          <p :class="s.campaign_text_wrap">
            <span :class="s.campaign_text_pinkBorder">アンケート回答</span>
            <span> + </span>
            <span :class="s.campaign_text_pinkBorder">公式Xフォロー</span>
            <span :class="s.campaign_text_nowrap">
              <a :class="s.campaign_x_link" href="https://x.com/seeboncho" target="_blank">
              <span :class="s.campaign_text_pinkBorder">@seeboncho</span>
              </a>
              <span>だけ！</span>
            </span>
          </p>
          <!-- <p>
            <span>さらに、</span>
            <span :class="s.campaign_text_yellowMarker">動画を視聴して感想を書けば</span>
          </p>
          <p>
            <span>プレゼントの</span>
            <span :class="s.campaign_text_yellowMarker">当選確率がUP!!</span>
          </p> -->
        </div>
      </div>
      <div :class="s.campaign_card">
        <div :class="s.campaign_movie_wrap">
          <!-- <img
            @click="flag.showVideo = true"
            :class="s.campaign_movie" src="/img/thumbnails/choikulove-4.jpg" alt=""> -->
          <div
            :class="[s.campaign_movie, s.youtube]" v-html="videoSrc"/>
          <img :class="s.campaign_movie_frame" src="/img/effects/movie_frame.svg" alt="">
          <div :class="s.campaign_movie_title_wrap">
            <div :class="s.campaign_movie_title">
              限定グッズ紹介！
            </div>
            <div :class="s.campaign_movie_title_back"></div>
          </div>
        </div>
        <div :class="s.campaign_comment">
          <div :class="s.campaign_comment_text">
            <span>Choiku LOVE限定Tシャツ｜</span><span>トートバッグ｜</span><span>ぬいぐるみチャームを</span><span>抽選でプレゼント！</span>
          </div>
        </div>
      </div>
      <div :class="[s.campaign_item, s.campaign_item_tshirt]">
        <img :class="[s.campaign_item_title, s.campaign_item_title_tshirt]" src="/img/pages/choikulove/specialcampaign/tshirt-title.svg" alt="">
        <div :class="s.campaign_item_title_sub">
          <span>デザイン３種×カラー３種</span>
          <span :class="s.campaign_item_title_sub_after">!</span>
        </div>
        <div :class="s.campaign_item_box">
          <div :class="[s.campaign_item_content_wrap, s.campaign_item_content_wrap_100]">
            <img
              :class="[s.campaign_item_content, s.campaign_item_content_100, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/t-a.png"
              alt=""
              @click="openImageModal('t-a')"
            >
          </div>
          <div :class="s.campaign_item_content_wrap">
            <img
              :class="[s.campaign_item_content, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/t-b.png"
              alt=""
              @click="openImageModal('t-b')"
            >
          </div>
          <div :class="s.campaign_item_content_wrap">
            <img
              :class="[s.campaign_item_content, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/t-c.png"
              alt=""
              @click="openImageModal('t-c')"
            >
          </div>
        </div>
      </div>
      <div :class="[s.campaign_item, s.campaign_item_bag]">
        <img :class="[s.campaign_item_title, s.campaign_item_title_bag]" src="/img/pages/choikulove/specialcampaign/bag-title.svg" alt="">
        <div :class="s.campaign_item_title_sub">
          <span>デザイン３種×カラー３種</span>
          <span :class="s.campaign_item_title_sub_after">!</span>
        </div>
        <div :class="s.campaign_item_box">
          <div :class="[s.campaign_item_content_wrap, s.campaign_item_content_wrap_100]">
            <img
              :class="[s.campaign_item_content, s.campaign_item_content_100, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/bag-a.png"
              alt=""
              @click="openImageModal('bag-a')"
            >
          </div>
          <div :class="s.campaign_item_content_wrap">
            <img
              :class="[s.campaign_item_content, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/bag-b.png"
              alt=""
              @click="openImageModal('bag-b')"
            >
          </div>
          <div :class="s.campaign_item_content_wrap">
            <img
              :class="[s.campaign_item_content, s.clickable]"
              src="/img/pages/choikulove/specialcampaign/bag-c.png"
              alt=""
              @click="openImageModal('bag-c')"
            >
          </div>
        </div>
      </div>
      <div :class="[s.campaign_item, s.campaign_item_charm]">
        <img :class="[s.campaign_item_title, s.campaign_item_title_charm]" src="/img/pages/choikulove/specialcampaign/charm-title.svg" alt="">
        <div :class="[s.campaign_item_content, s.campaign_item_content_charm]">
          <img
            :class="[s.campaign_item_content_img, s.clickable]"
            src="/img/pages/choikulove/specialcampaign/charm-text.png"
            alt=""
            @click="openImageModal('charm')"
          >
        </div>
      </div>
    </div>
    <div :class="s.campaign_award_wrap">
      <div :class="s.campaign_award">
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/a-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/a-shou-hukidashi.svg" alt="">
        </div>
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/b-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/b-shou-hukidashi.svg" alt="">
        </div>
        <div :class="s.campaign_award_item">
          <img :class="s.campaign_award_item_main"
          src="/img/pages/choikulove/specialcampaign/c-shou.png" alt="">
          <img :class="s.campaign_award_item_hukidashi" src="/img/pages/choikulove/specialcampaign/c-shou-hukidashi.svg" alt="">
        </div>
      </div>
    </div>
    <div :class="s.questionary">
      <div :class="s.questionary_header_bg">
        <div :class="s.questionary_start_wrap">
          <div :class="[s.questionary_toge, s.show]"></div>
          <img :class="s.questionary_hukidashi" src="/img/pages/choikulove/specialcampaign/q-header-hukidashi.svg" alt="">
          <div :class="s.questionary_start_content">
            <div :class="s.questionary_start_character">
              <img src="/img/pages/futureforecast/shibon.gif" alt="">
            </div>
            <a href="/enquete/" :class="s.questionary_start_btn">
              <dot-bg-btn>アンケートスタート<span :class="s.questionary_italic">!!</span></dot-bg-btn>
            </a>
            <img :class="s.questionary_arrow" src="/img/pages/choikulove/specialcampaign/arrow.svg" alt="">
          </div>
        </div>
      </div>
      <div :class="s.questionary_content">
        <div :class="s.questionary_item">
          <div :class="s.questionary_item_title">応募期間</div>
          <div :class="s.questionary_cloud_box">
            <div :class="s.questionary_cloud_box_content">
              <div :class="s.questionary_cloud_box_content_text_wrap">
                <div :class="s.questionary_cloud_box_content_text">2025年</div>
                <div :class="s.questionary_cloud_box_content_text">
                  <span :class="s.questionary_cloud_box_1_span_big">12</span>
                  <span :class="s.questionary_cloud_box_1_span">月</span>
                  <span :class="s.questionary_cloud_box_1_span_big">9</span>
                  <span :class="s.questionary_cloud_box_1_span">日（火）~</span>
                  <span :class="s.questionary_cloud_box_1_span_big">12</span>
                  <span :class="s.questionary_cloud_box_1_span">月</span>
                  <span :class="s.questionary_cloud_box_1_span_big">26</span>
                  <span :class="s.questionary_cloud_box_1_span">日（金）</span>
                </div>
              </div>
              <div :class="s.questionary_cloud_box_content_text">
                <span :class="s.questionary_cloud_box_1_span">23:59</span>
                <span :class="s.questionary_cloud_box_1_span_small">までの</span>
                <span :class="s.questionary_cloud_box_1_span">回答</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div :class="s.questionary_item">
          <div :class="s.questionary_item_title">応募資格</div>
          <div :class="[s.questionary_cloud_box, s.questionary_cloud_box_2]">
            <p :class="s.questionary_cloud_box_content_text_28">15～18歳の高校生</p>
            <p :class="s.questionary_cloud_box_content_text_16">※自称高校生の参加は不問とします</p>
          </div>
        </div> -->
        <div :class="s.questionary_item">
          <div :class="s.questionary_item_title">応募規約</div>
          <div :class="[s.questionary_cloud_box, s.questionary_cloud_box_2]">
            <img :class="s.questionary_cloud_box_bg" src="/img/pages/choikulove/specialcampaign/gizagiza.svg" alt="">
            <div ref="termsButton" :class="s.questionary_cloud_box_btn" @click.stop="triggerTermsClicked">
              <div :class="s.questionary_cloud_box_btn_img">
                <img src="/img/pages/choikulove/specialcampaign/btn-accordion.svg" alt="くわしくはコチラ">
              </div>
            </div>
            <div
              id="terms-accordion-content"
              :class="[s.terms_accordion, flag.showTerms ? s.show : '']">
              <div :style="`max-height: ${accordionMaxH}px;`">
                <div :class="s.terms_accordion_content">{{ termsText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 画像拡大モーダル -->
    <ModalsContainer />
    <VueFinalModal
      v-model="showModal"
      :class="s.modal_overlay"
      content-class="modal_content"
      overlay-transition="vfm-fade"
      content-transition="vfm-fade"
      :click-to-close="true"
      :esc-to-close="true"
      @update:model-value="(val) => !val && closeImageModal()"
    >
      <div :class="s.modal_container">
        <button :class="s.modal_close_btn" @click="closeImageModal">✕</button>

        <!-- スクロールコンテナ -->
        <div :class="s.modal_scroll_container" id="modal-scroll-container">
          <div :class="s.modal_scroll_content" id="modal-scroll-content">
            <!-- Tシャツ: 表裏2画像、バッグ: 表面のみ、チャーム: 単一画像 -->
            <div
              v-for="(side, index) in (modalImageType === 'tshirt' ? ['front', 'back'] : ['front'])"
              :key="index"
              :class="s.modal_image_wrap"
            >
              <img
                v-if="modalImageType === 'charm'"
                :class="s.modal_image"
                src="/img/pages/choikulove/specialcampaign/charm-up.jpg"
                alt="チャーム"
              >
              <img
                v-else
                :class="s.modal_image"
                :src="`/img/pages/choikulove/specialcampaign/${currentModalImagePrefix}-up-${side}.jpg`"
                :alt="`${side === 'front' ? '表面' : '裏面'}`"
              >
            </div>
          </div>
        </div>

        <!-- 左右の矢印ボタン（Tシャツのみ） -->
        <div v-if="modalImageType === 'tshirt'" :class="s.modal_arrows">
          <div
            v-show="modalImageIndex > 0"
            :class="[s.modal_arrow, s.modal_arrow_prev]"
            @click.stop="prevModalImage"
          />
          <div
            v-show="modalImageIndex < 1"
            :class="[s.modal_arrow, s.modal_arrow_next]"
            @click.stop="nextModalImage"
          />
        </div>
      </div>
    </VueFinalModal>
  </div>
</template>

<script>
import { VueFinalModal, ModalsContainer } from 'vue-final-modal';
import { DotBgBtn } from '@/components/parts';

export default {
  name: 'ChoikuLoveSpecialCampaign',
  components: {
    DotBgBtn,
    VueFinalModal,
    ModalsContainer,
  },
  data() {
    return {
      flag: {
        showTerms: false,
        showVideo: false,
      },
      // モーダル画像切り替え用
      modalImageType: null, // 'tshirt' | 'bag' | null
      modalImageId: null, // 'a' | 'b' | 'c' | null
      modalImageIndex: 0, // 0: front, 1: back
      scrollTimer: null, // スクロール監視用タイマー
      scrollListener: null, // スクロールイベントリスナーの参照
      videoSrc: `
        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/jO4V_LsrQSo?si=OiRiUAwKsFCzMoka" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      `,
      accordionMaxH: 0,
      clickOutsideListener: null,
      termsText: `[運営事務局]
本キャンペーンは「一般社団法人投資信託協会」が主催し、キャンペーン事務局が運営しております。なお、適正な運用を行う為に事務局が必要と判断した場合に限り、本キャンペーンの応募条件変更等、あらゆる対応を取ることができるものとさせていただきます。あらかじめご了承ください。詳しくはその他の注意事項をご確認ください。
[キャンペーン名]
ちょいくプロジェクト "CHOIKULOVE"キャンペーン
[商品]
A 賞 シーボンチャーム＋... T シャツ＋トートバッグセット...5 名
B 賞 シーボンチャーム＋... T シャツセット...15 名
C 賞 シーボンチャーム... ...50 名
※T シャツ・トートバッグはそれぞれ複数のデザインをご用意しており、お届けする商品は
ランダムとなります。デザインのご指定はできませんので、あらかじめご了承ください。
本キャンペーン募集の内容および賞品は、予告なく変更される場合があります※
[応募期間]
2025 年12 月9 日（火）〜 12 月26 日（金）23:59 までのご応募
[当選人数]
合計70名様
[賞品発送]
賞品発送はキャンペーン応募期間終了後の1月中旬頃を予定しております。都合により賞品の発送が多少遅れる場合もございます。当選者の発表は、商品の発送をもって代えさせていただきます。当選者には公式X アカウントより、DM にてご連絡いたします。その際、賞品のお送り先をお伺いいたします。DM が開放されていないなど、こちらからコンタクトを取ることが不可能な場合は、当選無効とさせていただきます。
[その他の注意事項]
本キャンペーンについては下記をお読みいただき、同意いただける場合のみご応募ください。
1. 本キャンペーンに応募していただくにあたり、応募者はキャンペーンの運用について事務局の運用方法にしたがうものとし、一切異議申立てを行わないものとします。
2. 本キャンペーンの当選連絡および賞品発送に関する連絡に関して、事務局からご連絡をさせていただく場合がございます。
3. 本キャンペーンサイトの利用・利用停止・もしくは不能による損害について事務局は一切責任を負いかねます。（各種WEB サービスのサーバーダウンなども含む）
4. 本サイトの理由によるいかなるトラブル・損害（直接、間接の損害別を問わず）が発生したとしても一般社団法人投資信託協会は一切の責任を負いません。あらかじめご了承くだ
さい。
5. ご応募いただく際にお預かりする皆様の個人情報の保護方針については、一般社団法人投資信託協会ホームページ内の「プライバシーポリシー」及び「コミュニティガイドライン」に記載しております。必ずご一読の上、同意した上でご応募ください。なお、本キャンペーンにご応募された方は、本プライバシーポリシーに同意したものとみなします。
6. キャンペーンの応募状況及び抽選結果に関するお問い合わせにはお答えしかねますので、予めご了承ください。
7. ご応募は日本国内にお住まいの方に限らせていただきます。
8. 抽選で獲得された権利は他人に譲渡できません。転売等はお控えください。
9. 本キャンペーンはX 社とは一切関係ありません。お問い合わせに関しては、下記お問い合わせ先までご連絡ください。
[禁止事項]
応募を通じて、以下の事項に該当するアカウントからの応募は無効とさせていただく場合があります。
また当選後に判明した場合も、当選権利を無効とさせていただく場合があります。
・X の利用規約に違反している。
・自動プログラムを利用しての応募。
・複数のX アカウントからの応募。
・代理応募。（親族の代理応募も禁止となります）
・本キャンペーンの運営を妨げる行為。
・特定の団体や個人に対する誹謗中傷。
・公序良俗に反する行為。
・宣伝及び勧誘行為。
・その他、運営事務局が不適切だと判断した行為。
[賠償責任]
本サイトの利用に関連して利用者と第三者との間に紛争が発生した場合には、利用者は、自身の責任と費用で当該紛争を解決するものとし、一般社団法人投資信託協会に損害を与えることのないようにするものとします。
[準拠法および裁判管轄]
本キャンペーン規約の解釈・適用に関しましては、日本国法に準拠するものといたします。
[お問い合わせ]
このキャンペーンに関するお問い合わせは下記までDM でお願いいたします。
ちょいくプロジェクト公式X アカウント（＠seeboncho）
受付時間　9:00～17:00（土・日・祝日を除く）`,
    };
  },
  computed: {
    showModal() {
      return this.modalImageType !== null && this.modalImageId !== null;
    },
    flagShowTerms() {
      return this.flag.showTerms;
    },
    // 現在のモーダル画像のプレフィックス（例: 't-a', 'bag-b'）
    currentModalImagePrefix() {
      if (!this.modalImageType || !this.modalImageId) return '';
      const prefix = this.modalImageType === 'tshirt' ? 't' : 'bag';
      return `${prefix}-${this.modalImageId}`;
    },
  },
  methods: {
    openImageModal(imageId) {
      // imageId例: 't-a', 't-b', 'bag-a', 'bag-b', 'charm'
      if (imageId === 'charm') {
        this.modalImageType = 'charm';
        this.modalImageId = 'charm';
        this.modalImageIndex = 0;
        return;
      }

      const parts = imageId.split('-');
      const type = parts[0]; // 't' or 'bag'
      const id = parts[1]; // 'a', 'b', 'c'

      this.modalImageType = type === 't' ? 'tshirt' : 'bag';
      this.modalImageId = id;
      this.modalImageIndex = 0; // 常に表面から開始

      // モーダルが開いたら、初期スクロール位置を設定（Tシャツのみ）
      // VueFinalModalのDOM挿入を待つため、setTimeoutを使用
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.modalImageType === 'tshirt') {
            this.scrollModalImage(0);
          }
        }, 100);
      });
    },
    closeImageModal() {
      this.modalImageType = null;
      this.modalImageId = null;
      this.modalImageIndex = 0;
    },
    // モーダル内で前の画像へ（表←裏）
    prevModalImage() {
      if (this.modalImageIndex > 0) {
        this.modalImageIndex -= 1;
        this.scrollModalImage(this.modalImageIndex);
      }
    },
    // モーダル内で次の画像へ（表→裏）
    nextModalImage() {
      if (this.modalImageIndex < 1) {
        this.modalImageIndex += 1;
        this.scrollModalImage(this.modalImageIndex);
      }
    },
    // スクロール位置を調整（WhatChoiku.vueのscrollCharacterを参考）
    scrollModalImage(targetIndex) {
      const scrollContainer = document.getElementById('modal-scroll-container');
      const scrollContent = document.getElementById('modal-scroll-content');
      if (!scrollContainer || !scrollContent) return;

      const containerPosX = scrollContainer.getBoundingClientRect().x;
      const contentPosX = scrollContent.getBoundingClientRect().x;
      const imageW = scrollContainer.clientWidth; // 各画像の幅 = コンテナ幅
      const scrolledX = (containerPosX + 1) - contentPosX;

      // targetIndexがない場合は現在位置から最も近いインデックスを計算
      this.modalImageIndex = targetIndex !== undefined
        ? targetIndex
        : Math.round(scrolledX / imageW);

      const targetX = this.modalImageIndex * imageW - scrolledX;

      scrollContainer.scrollBy({
        left: targetX,
        behavior: 'smooth',
      });
    },
    // スクロール位置から画像インデックスを更新してスナップ
    updateModalImageIndexFromScroll() {
      this.scrollModalImage(); // targetIndexなしで呼び出し→自動スナップ
    },
    triggerTermsClicked() {
      this.flag.showTerms = !this.flag.showTerms;
      if (this.flag.showTerms) {
        const winH = window.innerHeight;
        const accordionElem = document.getElementById('terms-accordion-content');
        const elemPos = accordionElem?.getBoundingClientRect().top;
        if (!accordionElem || !winH) return;
        const bottomLen = winH - elemPos;
        this.accordionMaxH = bottomLen - 20;
      }
    },
    handleClickOutside(event) {
      const accordionContent = document.getElementById('terms-accordion-content');
      const termsButton = this.$refs.termsButton;

      // ボタンクリックは無視（triggerTermsClickedが処理するため）
      if (termsButton && termsButton.contains(event.target)) return;

      // アコーディオン内部のクリックは無視
      if (accordionContent && accordionContent.contains(event.target)) return;

      // 外側クリック → 閉じる
      this.flag.showTerms = false;
    },
  },
  watch: {
    flagShowTerms(newVal) {
      if (newVal) {
        // 開いたら次のティックでリスナー追加
        this.$nextTick(() => {
          this.clickOutsideListener = this.handleClickOutside.bind(this);
          document.addEventListener('click', this.clickOutsideListener);
        });
      } else if (this.clickOutsideListener) {
        // 閉じたらリスナー削除
        document.removeEventListener('click', this.clickOutsideListener);
        this.clickOutsideListener = null;
      }
    },
    // モーダル開閉時にスクロールイベントリスナーを管理（Tシャツのみ）
    showModal(newVal) {
      if (newVal) {
        // モーダルが開いたらリスナーを追加（Tシャツのみ）
        // VueFinalModalのDOM挿入を待つため、setTimeoutを使用
        this.$nextTick(() => {
          setTimeout(() => {
            const scrollContainer = document.getElementById('modal-scroll-container');
            if (scrollContainer && this.modalImageType === 'tshirt') {
              this.scrollListener = () => {
                if (this.scrollTimer !== false) clearTimeout(this.scrollTimer);
                this.scrollTimer = setTimeout(() => {
                  this.updateModalImageIndexFromScroll();
                }, 200);
              };
              scrollContainer.addEventListener('scroll', this.scrollListener);
            }
          }, 100);
        });
      } else {
        // モーダルが閉じたらリスナーを削除
        const scrollContainer = document.getElementById('modal-scroll-container');
        if (scrollContainer && this.scrollListener) {
          scrollContainer.removeEventListener('scroll', this.scrollListener);
          this.scrollListener = null;
        }
      }
    },
  },
  beforeUnmount() {
    // コンポーネント破棄時にリスナーをクリーンアップ
    if (this.clickOutsideListener) {
      document.removeEventListener('click', this.clickOutsideListener);
    }
  },
};
</script>

<style>
.vfm--overlay {
  background-color: transparent!important;
}
</style>

<style lang="scss" module="s">

.container {
  position: relative;
  padding-top: 50px;
  padding-bottom: 200px;
  background-color: #ffd2bf;
  text-align: center;
  z-index: 25;

  @include mdView {
    padding-bottom: 150px;
  }

  @include smView {
    padding-bottom: 100px;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    display: block;
    width: 100vw;
    height: 56px;
    background-image: url(/img/pages/choikulove/specialcontent/bg-pattern.svg);
    background-repeat: repeat-x;
    background-size: contain;
    background-position: center 0;

    @include mdView {
      height: 40px;
    }

    @include smView {
      height: 25px;
    }
  }

  &::before {
    top: 0;
    background-color: var(--primary-yellow);
  }

  &::after {
    bottom: 0;
    rotate: 180deg;
    background-color: var(--primary-green);
  }
}

.header {
  margin: 0 auto;
}

.header_title {
  position: relative;
  width: calc(1665 / 1920 * 100%);
  max-width: 1665px;
  z-index: 3;

  @include smView {
    width: 100%;
  }
}

.header_mainCopy {
  position: relative;
  width: calc(1307/1920 * 100%);
  max-width: 1307px;
  z-index: 3;
  margin-top: -7vw;

  @include smView {
    width: 85%;
  }
}

.campaign_card {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  @include mdView {
    align-items: center;
  }

  @include smView {
    flex-direction: column;
    width: 95%;
  }
}

.campaign_movie_wrap {
  position: relative;
  width: calc(1030/1920 * 100%);
  max-width: 1030px;
  max-height: 16383px;
  height: fit-content;
  z-index: 4;

  @include smView {
    width: 100%;
  }
}

.campaign_movie {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 89%;
  height: 83%;
  transform: translate(-50.55%, -51%);
  margin: 0 auto;
  &.youtube {
    z-index: 3;
  }
}

.campaign_movie_frame {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 4;
  pointer-events: none;
}

.campaign_comment {
  position: relative;
  background-image: url('/img/pages/choikulove/specialcontent/comment-frame.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
  margin-left: -6%;
  width: clamp(455px, 32.3958333333%, 545px);
  aspect-ratio: 622/618;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mdView {
    width: min(369px, 50%);
    margin-left: -7%;
  }

  @include smView {
    margin-left: 0;
    margin-right: -36vw;
    translate: 0 -10vw;
    width: max(290px, 60%);
  }
}

.campaign_movie_title_wrap {
  position: absolute;
  z-index: 5;
  top: 1.2%;
  left: 100%;
  translate: -18% 0;
  width: fit-content;
  height: auto;
  transform: rotate(-5deg);
  transform-origin: center;

  @include mdView {
    top: -3.5%;
    left: 0;
    translate: -3% -45%;
  }
}

.campaign_movie_title {
  position: relative;
  z-index: 5;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  width: 100%;
  height: auto;
  background-color: var(--primary-green);
  border: 1px solid var(--primary-black);
  border-radius: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 80px;
  white-space: nowrap;

  @include mdView {
    font-size: 20px;
    padding: 14px 40px;
  }
  @include smView {
    font-size: 15px;
    padding: 7px 20px;
  }
}

.campaign_movie_title_back {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  border-radius: 50px;

  @include smView {
    top: 5px;
    left: 5px;
  }
}

.campaign_comment_text {
  position: relative;
  z-index: 4;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.5;
  width: min(calc(100% - 100px * 2), 80%);
  padding-top: 4%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 6%;

  @include mdView {
    width: 60%;
    font-size: 17px;
    padding-top: 0px;
    padding-left: 4%;
  }

  @include smView {
    font-size: max(13px, 2.5vw);
    padding-left: 0;
  }

  span {
    white-space: nowrap;
  }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6vw;
  max-width: 1450px;
  margin: 0 auto;
  margin-top: calc(-100 / 1920 * 100%);
  background-image: url('/img/pages/choikulove/bg-dot-kumo.svg');
  background-size: min(39%, 750px) 96%;
  background-repeat: no-repeat;
  background-position: center;

  @include mdView {
    background-size: 50% 96%;
  }

  @include smView {
    background-size: 75% 96%;
  }
}

.campaign_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  position: relative;
  width: 95%;
  height: auto;
  z-index: 3;
  background-image: url('/img/pages/choikulove/specialcampaign/white-kumo1.svg');
  background-repeat: no-repeat;
  background-position: center;
  padding: 7% 7% 4%;
  background-size: contain;
  max-width: 1260px;

  @include smView {
    padding: 11% 11% 7%;
    gap: 14px;
    margin-bottom: 25px;
  }
}

.campaign_mainCopy {
  position: relative;
  width: 80%;
  z-index: 3;
  margin-top: -12%;

  @include mdView {
    margin-top: -10%;
  }

  @include smView {
    margin-top: -16%;
  }
}

.campaign_intro {
  position: relative;
  width: 85%;
  z-index: 3;

  @include smView {
    width: 100%;
  }
}

.campaign_yellowKumo {
  position: relative;
  width: 34%;
  height: auto;
  z-index: 3;

  @include smView {
    width: 37vw;
  }
}

.campaign_text {
  font-size: 26px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @include smView {
    font-size: 3vw;
  }
}

.campaign_text_pinkBorder {
  border-bottom: 9px solid var(--primary-pink);
  line-height: 1.4;

  @include smView {
    border-bottom: 3px solid var(--primary-pink);
  }
}

.campaign_text_nowrap {
  white-space: nowrap;
}

.campaign_x_link {
  text-decoration: none;
  white-space: nowrap;
}

.campaign_text_yellowMarker {
  background-color: var(--primary-yellow);
}

.campaign_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  width: 95%;
  z-index: 3;
  background-image: url('/img/pages/choikulove/specialcampaign/white-kumo1.svg');
  background-repeat: no-repeat;
  background-position: center;
  padding: 7%;
  background-size: 100% 100%;
  max-width: 1452px;
  aspect-ratio: 1452 / 607;
  margin-bottom: 50px;

  @include mdView {
    gap: 12px;
    margin-bottom: 40px;
  }

  @include smView {
    margin-bottom: 20px;
    gap: 10px;
    padding: 10% 11% 8%;
    aspect-ratio: 2 /1;
    background-image: url(/img/effects/cloud_bg.png);
    background-size: 100% 100%;
  }
}

.campaign_item_title {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 367px;
  z-index: 4;
  height: auto;
  translate: 0 -30%;

  @include mdView {
    width: 28vw;
  }

  @include smView {
    width: 33vw;
  }
}

.campaign_item_title_sub {
  font-size: 43px;
  font-weight: 700;
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  @include mdView {
    font-size: 24px;
  }

  @include smView {
    font-size: 15px;
  }
}

.campaign_item_title_sub_after {
  transform: rotate(27deg);
}

.campaign_item_box {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;

  @include mdView {
    gap: 20px;
  }

  @include smView {
    gap: 0;
    flex-wrap: wrap;
  }
}

.campaign_item_content_wrap {
  width: 33%;
  @include smView {
    width: 50%;
  }
}

.campaign_item_content_wrap_100 {
  @include smView {
    width: 100%;
  }
}

.campaign_item_content {
  position: relative;
  width: 100%;
  z-index: 4;

  @include smView {
    width: 100%;
  }
}

.campaign_item_content_100 {
  @include smView {
    width: 50%;
  }
}

.campaign_item_tshirt .campaign_item_bag{
  background-image: url('/img/pages/choikulove/specialcampaign/white-kumo2.svg');

  @include smView {
    background-image: url('/img/effects//campaign_how_to.png');
  }
}

.campaign_item_charm {
  background-image: url('/img/pages/choikulove/specialcampaign/white-kumo4.svg');
  aspect-ratio: 1177 / 613;
  max-width: 1177px;
  padding-block: 0;

  @include mdView {
    width: 80%;
  }

  @include smView {
    max-width: 100%;
  }
}

.campaign_item_content_charm {
  width: 37%;
  position: relative;
  z-index: 4;

  @include mdView {
    width: 45%;
  }

  @include smView {
    width: 67%;
  }
}

.campaign_item_content_img {
  translate: 10% 0;
}

.campaign_award_wrap {
  position: relative;
  z-index: 4;
  width: 100%;
  background-image: url('/img/pages/choikulove/specialcampaign/award-bg.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 95% 95%;
}

.campaign_award {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 27px;
  width: min(calc(100% - 60px * 2),1450px);
  margin: 0 auto;
  padding-bottom: 10px;

  @include smView {
    gap: 3px;
    padding-inline: 5px 15px;
    width: 100%;
    padding-bottom: 80px;
  }
}

.campaign_award_item {
  position: relative;
  z-index: 4;
  width: 33%;

  &::before {
    content: '';
    position: absolute;
    top: 1%;
    left: 0;
    right: 0;
    z-index: 1;
    width: 25%;
    margin: 0 auto;
    aspect-ratio: 5 / 9;
    transform-origin: bottom center;
    animation: sway 2s ease-in-out infinite alternate;
    background: transparent url(/img/items/me.png) center no-repeat;
    background-size: contain;
    translate: -16% 4%;;
  }

  @include smView {
    width: 80%;
  }
}

@keyframes sway {
  0% {
    transform: rotate(-25deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(-37deg);
  }
}

.campaign_award_item_main{
  position: relative;
  z-index: 4;
}

.campaign_award_item_hukidashi {
  position: absolute;
  z-index: 5;
  top: 4vw;
  right: -4vw;
  width: 40%;
  height: auto;
}

.questionary_content {
  position: relative;
  z-index: 4;
  margin: 0 auto;
  width: 80%;

  @include smView {
    width: 85%;
  }
}

.questionary_item {
  position: relative;
  z-index: 4;
  margin-top: 20px;
}

.questionary_item_title {
  font-size: 42px;
  font-weight: 700;
  position: relative;
  z-index: 5;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  border-radius: 100px;
  max-width: 312px;
  width: 20vw;
  padding: 16px 0;
  margin: 0 auto;
  margin-bottom: -4%;

  @include mdView {
    font-size: 25px;
  }

  @include smView {
    font-size: 16px;
    padding: 7px 0;
    min-width: 100px;
  }
}

.questionary_cloud_box {
  position: relative;
  z-index: 4;
  background-image: url('/img/pages/choikulove/specialcampaign/q-white-kumo-1.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 5%;
  width: 100%;
  max-width: 1052px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 0 auto;

  @include smView {
    background-image: url('/img/pages/choikulove/specialcampaign/q-white-kumo-2.svg');
    gap: 10px;
    background-size: 100% 100%;
    width: 100%;
  }
}

.questionary_cloud_box_2 {
  background-image: url('/img/pages/choikulove/specialcampaign/q-white-kumo-2.svg');
  width: 100%;
  max-width: 1052px;
  padding-block: 6.5%;

  @include smView {
    background-size: 100% 100%;
    aspect-ratio: auto;
    padding: 6% 2%;
    gap: 10px;
  }
}

.questionary_cloud_box_content {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  @include smView {
    gap: 5px;
  }
}

.questionary_cloud_box_content_item {
  position: relative;
  z-index: 4;
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.questionary_cloud_box_content_img {
  position: relative;
  z-index: 4;
  width: 9.8%;

  @include smView {
    width: 18%;
  }
}

.questionary_cloud_box_content_text_wrap {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  white-space: nowrap;
  gap: 5px;
}

.questionary_cloud_box_content_span {
  display: inline;

  @include mdView {
    display: block;
  }
}

.questionary_cloud_box_content_text {
  font-size: 28px;
  font-weight: 700;

  @include mdView {
    font-size: 24px;
    text-align: justify;
  }

  @include smView {
    font-size: 11px;
  }
}

.questionary_cloud_box_1_span_big {
  font-size: 60px;

  @include mdView {
    font-size: 40px;
  }

  @include smView {
    font-size: 21px;
  }
}

.questionary_cloud_box_1_span_small {
  font-size: 21px;

  @include mdView {
    font-size: 14px;
  }

  @include smView {
    font-size: 10px;
  }
}

.questionary_cloud_box_content_text_28 {
  font-size: 50px;
  font-weight: 700;

  @include mdView {
    font-size: 36px;
  }
  @include smView {
    font-size: 19px;
  }
}

.questionary_cloud_box_content_text_16 {
  font-size: 22px;
  font-weight: 700;

  @include smView {
    font-size: 12px;
  }
}

.questionary_cloud_box_bg {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 100%;
  object-fit: contain;
}

.questionary_cloud_box_btn {
  position: relative;
  z-index: 2;
}

.questionary_cloud_box_btn_img {
  position: relative;
  width: 25vw;
  min-width: 100px;

  img {
    position: relative;
    display: block;
    z-index: 2;
    transition: transform 300ms;
    transform: translate(-0.4vw, -0.4vw);
  }

  &:hover {
    img {
      transform: translate(.4vw, .4vw);
    }
  }

  &::before {
    position: absolute;
    width: 25vw;
    min-width: 100px;
    z-index: 1;
    content: "";
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(calc(-50% + 0.4vw), calc(-50% + 0.4vw));
    background-image: url(/img/pages/choikulove/specialcampaign/btn-accordion_bg.svg);
    transition: all 0.3s;
    background-repeat: no-repeat;
  }
}

.questionary_header_bg {
  position: relative;
  z-index: 4;
  width: 100%;
  height: 100%;
  aspect-ratio: 2 / 1;
  background-image: url('/img/pages/choikulove/specialcampaign/questionary-header-bg.svg');
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 95% 95%;
  padding-top: 10px;
}

/* FutureForecast.vueからコピーしたスタイル */
.questionary_start_wrap {
  width: 100%;
  max-width: 1343px;
  position: relative;
  padding: 0 16px;
  margin-top: 10%;
  margin-inline: auto;
}

.questionary_start_content {
  width: 100%;
  position: absolute;
  z-index: 3;
  left: 50%;
  top: 0;
  transform: translate(-50%, -5%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.questionary_start_character {
  position: absolute;
  z-index: 4;
  bottom: 50%;
  width: 35%;
}

.questionary_start_character > img {
  transform: translateY(20%);
}

.questionary_start_btn {
  position: absolute;
  top: 45%;
  transition: top 0.4s ease, left 0.4s ease;
  z-index: 5;

  &:active {
    transform: none;
  }
}

.questionary_toge {
  position: relative;
  z-index: 1;
  padding-top: percentage(121 / 291);
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  transform-origin: center;
  background-image: url('/img/effects/togetoge_c.svg');
  margin: 0 auto;
  opacity: 1;
}

.questionary_hukidashi {
  position: absolute;
  z-index: 2;
  top: -16%;
  right: 3%;
  width: 44%;
  height: auto;
  background-image: url('/img/pages/choikulove/specialcampaign/comment-kumo.svg');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.questionary_arrow {
  position: absolute;
  z-index: 3;
  top: -18%;
  left: 24%;
  width: 8.45%;
  animation: poke 1.6s infinite ease-in-out;

  @include smView {
    width: 7.5%;
  }
}

@keyframes poke {
  0% { translate: 0 0; }
  15% { translate: -7% -2%; }
  30% { translate: 7% 2%; }
  45% { translate: -7% -2%; }
  60% { translate: 7% 2%; }
  75% { translate: 0 0; }
  100% { translate: 0 0; }
}

.questionary_italic {
  font-style: italic;
}

/* アニメーション関連のスタイル */
.questionary_toge.show {
  opacity: 1;
}

.questionary_toge {
  animation: questionary_shake 2s infinite, questionary_flash 1s infinite;
}

@keyframes questionary_shake {
  0% { transform: rotate(0deg); }
  5% { transform: rotate(-2deg); }
  10% { transform: rotate(2deg); }
  15% { transform: rotate(-2deg); }
  20% { transform: rotate(2deg); }
  25% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
}

@keyframes questionary_flash {
  0% { background-image: url('/img/effects/togetoge_a.svg');}
  32% { background-image: url('/img/effects/togetoge_a.svg');}
  33% { background-image: url('/img/effects/togetoge_c.svg');}
  65% { background-image: url('/img/effects/togetoge_c.svg');}
  66% { background-image: url('/img/effects/togetoge_b.svg');}
  99% { background-image: url('/img/effects/togetoge_b.svg');}
  100% { background-image: url('/img/effects/togetoge_a.svg');}
}

/* 応募規約アコーディオンのスタイル */
.terms_accordion {
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: var(--primary-white);
  width: 80%;
  margin: 0 auto;
  font-weight: 600;
  transform-origin: top;
  transform: translateX(-50%);
  max-height: 0;
  text-align: left;
  z-index: 0;

  > * {
    height: 100vh;
    overflow: scroll;
    width: 100%;
    padding: 40px;
    background-color: var(--primary-white);
    border: 1px solid var(--primary-black);
    border-top: none;
    transition: all .3s;
    transform-origin: top;
    transform: scaleY(0) translateY(0);
    border-radius: 0 0 15px 15px;

    @include smView {
      padding: 20px;
    }
  }

  &.show {
    > * {
      transform: scaleY(100%) translateY(0);
    }
  }
}

.terms_accordion_content {
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  font-weight: 600;

  @include smView {
    font-size: 12px;
  }
}

// モーダル関連のスタイル
.clickable {
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.02);
  }
}

.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(180 180 180 / 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal_container {
  position: relative;
  max-width: min(600px, 90vw);
  max-height: min(600px, 90vh);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5vw 3vw;
  background-repeat: none;
  background-size: 100% 100%;
  background-image: url("/img/effects/cloud_bg.png");

  @include smView {
    padding: 6vw;
  }
}

.modal_image {
  max-width: 100%;
  max-height: 90vh;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 8px;

  @include smView {
    max-width: 95vw;
  }
}

.modal_close_btn {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--primary-white);
  border: 2px solid var(--primary-black);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-black);
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  translate: 50%;
  transition: all 0.2s ease;
  appearance: none;

  &:hover {
    background-color: var(--primary-pink);
    transform: scale(1.1);
  }

  @include smView {
    translate: -20% 20%;
    width: 36px;
    height: 36px;
    font-size: 20px;
  }
}

// モーダル内のスクロールコンテナ
.modal_scroll_container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;

  // スクロールバーを非表示
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE, Edge

  &::-webkit-scrollbar {
    display: none; // Chrome, Safari
  }
}

// 横並びコンテナ
.modal_scroll_content {
  display: flex;
  height: 100%;
  width: fit-content;
}

// 各画像のラッパー
.modal_image_wrap {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

// モーダル内の矢印コンテナ
.modal_arrows {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9998;

  > div {
    position: absolute;
    width: 80px;
    height: 80px;
    background-image: url('/img/pages/whatchoiku/arrow.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    top: 50%;
    pointer-events: auto;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }

    @include mdView {
      width: 60px;
      height: 60px;
    }

    @include smView {
      width: 50px;
      height: 50px;
    }
  }
}

.modal_arrow_prev {
  left: 10px;
  transform: translateY(-50%);

  @include smView {
    left: 5px;
  }
}

.modal_arrow_next {
  right: 10px;
  translate: 0 -50%;
  rotate: 180deg;

  @include smView {
    right: 5px;
  }
}

</style>
